import admin from "./_admin";
import "../../setup/js/_toggleClass";
import "../../setup/js/_scaleRoot.2";
import "../../setup/js/_swiper";
import "../../setup/js/_universalLink";
import "../../setup/js/_scrollwatch";
import "../../setup/js/TweenMax.min";

// import "lazysizes";
// import "@fancyapps/fancybox";

window.addEventListener("load", function () {
  $("#loading").each(function () {
    setTimeout(() => {
      $("#loading").removeClass("active");
    }, 3000);

  });

  var url = new URL(window.location.href);
  var param_admin = url.searchParams.get("admin");
  //admin.init();
  admin.executeFunctions();

  $("#wrapper").scalePlatform();
  $(window).on("resize", function () {
    $("#wrapper").scalePlatform();
  });
  commonLibs();

  // $("[data-fancybox]").fancybox({
  //   infobar: false,
  //   arrows: false,
  //   keyboard: false,
  //   touch: false,
  //   animationEffect: false,
  //   transitionEffect: false,
  //   clickSlide: false,
  //   clickOutside: false,
  //   smallBtn: false,
  //   caption: function (instance, item) {
  //       // console.log($(this).find('figcaption'));
  //       // return $(this).find('figcaption').html();
  //   },
  //   afterLoad: function (instance, current) {
  //       let popupClassname = current.opts.fancybox;
  //       instance.current.$content.addClass(popupClassname + "-content");
  //       instance.current.$content.append("<span data-fancybox-close title='Close' class='close-fancybox'>Close</span>");
  //       instance.current.$content.parents(".fancybox-container").addClass(popupClassname + "-container");
  //       instance.current.$content.parents(".fancybox-inner").addClass(popupClassname + "-inner");
  //       instance.current.$content.parents(".fancybox-stage").addClass(popupClassname + "-stage");
  //       instance.current.$content.parent(".fancybox-slide").addClass(popupClassname + "-slide");

  //   }
  // });
});

var commonLibs = function () {
  $("#wrapper").scalePlatform();

  $(".onelink").each(function () {
    $(".onelink").universalLink();
  });

  $("#navBurger").each(function () {
    $("#navBurger").toggleClassname({
      toggle: [{
          el: $("#floattop"),
          className: "active",
        },
        {
          el: $("#floatnav"),
          className: "active",
        },
        {
          el: $("#navBurger"),
          className: "is-active",
        },
        {
          el: $("#navBurger"),
          className: "active",
        },
      ],
    });
  });

  $("#subwebBurger").each(function () {
    $("#subwebBurger").toggleClassname({
      toggle: [{
          el: $(".midbar__menu"),
          className: "active",
        },
        {
          el: $("#subwebBurger"),
          className: "is-active",
        },
      ],
    });
  });
  $(".floatnav--nav-5").each(function () {
    $(".floatnav--nav-5").toggleClassname({
      toggle: [{
          el: $(".dropdown-content"),
          className: "active",
        },

      ],
    });
  });

  $("#asideRightToggle").each(function () {
    $(this).toggleClassname({
      toggle: [{
          el: $(".floatright__main"),
          className: "active",
        },
        {
          el: $(".floatright .aside"),
          className: "active",
        },
      ],
    });
  });

  $(".scrollTop").each(function () {
    $(this).on("click", function () {
      $("html, body").animate({
        scrollTop: 0
      }, 400);
    });
  });

  if ($("[data-lightbox]").length > 0) {
    $("[data-lightbox]").each(function () {
      $(this).lightBox({
        objLightBox: $(this).attr('href'),
        type: $(this).data('lightbox-type')
      });
    });
  }

  $(".popup__close, .gr__button .btn__dongy").each(function () {
    $(this).on("click", function () {
      $(this).closest(".popup").removeClass("active");
      $(this).closest("section").removeClass("active");
      $("html").removeClass("popup-opened");
    });
  });

  var target;
  var actIframe = "";
  var imgUrl = "";

  $(".btn-openpopup").on("click", function (e) {
    target = $(this).data("target");
    $(target).toggleClass("active");
    $("#popup_thele iframe").attr("src", "");
    actIframe = $(this).attr("href");
    if (actIframe == "") {
      return false;
    } else {
      $("#popup_thele iframe").attr("src", actIframe);
      return false;
    }


    e.preventDefault();
  });
  $(".btn-openpopup").on("click", function (e) {

    $("#popup_detail img").attr("src", "");
    imgUrl = $(this).data("src");
    if (imgUrl == "") {
      return false;
    } else {
      $("#popup_detail img").attr("src", imgUrl);
      return false;
    }
    e.preventDefault();
  });


  // var video = document.getElementsByTagName("video")[0];
  // var sources = video.getElementsByTagName("source");
  // sources[0].src =
  //   "https://img.zing.vn/products/thiennhai/2024-dangkytruoc2/prod/metaslug_sinhnhat1tuoi/header_frame/images/video-header.mp4";
  // video.load();
  // if ($(window).width() < 999) {
  //   var video = document.getElementsByTagName("video")[0];
  //   var sources = video.getElementsByTagName("source");
  //   sources[0].src =
  //     "https://img.zing.vn/products/thiennhai/2024-dangkytruoc2/prod/metaslug_sinhnhat1tuoi/header_frame/images/video-header-mb.mp4";
  //   video.load();
  // }

};